import { render, staticRenderFns } from "./YearText.vue?vue&type=template&id=5795be36&"
import script from "./YearText.vue?vue&type=script&lang=js&"
export * from "./YearText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports